enum EEndpoints {
	listInsurances = "list/insurances",
	listLeasingdurations = "list/leasingdurations",
	listLegalforms = "list/legalforms",
	listResidualvalues = "list/residualvalues",
	calculateLeasing = "calculate/leasing",
}

export default EEndpoints;
